module.exports = __webpack_public_path__ + "static/img/logo-nife-original.24c84e74.png";